import axios from "axios";
import baseURL from "../configs/api";

export const post_VehicleClassFeatureMapping = (data: any[], userId: number, tenantId: string) => {
    return axios({
        url: `${baseURL}vehicleClassFeatureMapping/CreateBulkVehicleClassFeatureMapping?userId=${userId}`,
        method: "POST",
        headers: {
            'X-Tenant-ID': tenantId,
            "Content-Type": "application/json"
        },
        withCredentials: true,
        data: data
    }).then(response => response.data);
}

export const delete_VehicleClassFeatureMappingByVehicleClassId = (vehicleClassId: string, userId: number, tenantId: string) => {
    return axios({
        url: `${baseURL}vehicleClassFeatureMapping/DeleteVehicleClassFeatureMappingByVehicleClassId/${vehicleClassId}?userId=${userId}`,
        method: "DELETE",
        headers: {
            'X-Tenant-ID': tenantId,
        },
    }).then(response => response.data);
}

export const getVehicleClassFeatureMappingsByVehicleClassId = (vehicleClassId: number, tenantId: string) => {
    return getFetch(`vehicleClassFeatureMapping/GetVehicleClassFeatureMappingsByVehicleClassId/${vehicleClassId}`, tenantId);
}

const getFetch = (url: string, tenantId: string, params = {}) => {
    return axios({
        url: baseURL + url,
        method: "GET",
        headers: {
            'X-Tenant-ID': tenantId,
        },
        params: params
    }).then(response => response.data);
}